import { sendEvent } from './analytics';

class FPSMeasurer {
  constructor(map, options = {}) {
    this.options = options;
    this.map = map;
    this.frames = 0;
    this.totalTime = 0;
    this.totalFrames = 0;
    this.fps = null;
    this.fpsArray = [];
    this.timeout = null;

    this.map.on('movestart', this.onMoveStart);
    this.map.on('moveend', this.onMoveEnd);
  }

  onMoveStart = () => {
    this.frames = 0;
    this.time = performance.now();
    this.map.on('render', this.onRender);
  };

  onMoveEnd = () => {
    const now = performance.now();
    this.setFPS(now);
    this.frames = 0;
    this.time = null;
    this.map.off('render', this.onRender);
  };

  onRender = () => {
    this.frames += 1;
    const now = performance.now();
    if (now >= this.time + 1e3) {
      this.setFPS(now);
      this.frames = 0;
      this.time = now;
    }
  };

  setFPS = (now) => {
    this.totalTime += now - this.time;
    this.totalFrames += this.frames;
    this.fps = Math.round((1e3 * this.frames) / (now - this.time)) || 0;
    this.fpsArray = [...this.fpsArray, this.fps];
    if (this.options.onUpdate) {
      this.options.onUpdate(this.fps);
    }
  };

  onRemove = () => {
    this.map.off('render', this.onRender);
    this.map.off('movestart', this.onMoveStart);
    this.map.off('moveend', this.onMoveEnd);
    this.container.parentNode.removeChild(this.container);
    this.map = null;
    return this;
  };

  get median() {
    if (this.fpsArray.length === 0) return 0;
    const numbers = [...this.fpsArray];
    numbers.sort((a, b) => a - b);
    const middle = Math.floor(numbers.length / 2);
    return numbers.length % 2 === 0 ? (numbers[middle - 1] + numbers[middle]) / 2 : numbers[middle];
  }
}

export const initFPSMeasurer = (map) => {
  new FPSMeasurer(map, {
    onUpdate: value => {
      let measurerEvent;
      if (value < 30) {
        measurerEvent = 'low';
      } else if (value < 40) {
        measurerEvent = 'medium';
      } else {
        measurerEvent = 'high'
      }
      sendEvent(window.eventCategory, 'map_fps', measurerEvent);
    }
  })
};
